import {withRouter} from 'react-router-dom';

import {AggregateViewMainTable} from './AggregateViewMainTable';
import {SUMMATION_NAMES_ENUM} from '../../pojos/Dimensions';

class MetricAggregateViewMainTable extends AggregateViewMainTable {

    generateDisplayedHeaderId(displayedBucketIdArray) {
        return [
            SUMMATION_NAMES_ENUM.TOTAL,
            SUMMATION_NAMES_ENUM.EARLIER_TOTAL,
            SUMMATION_NAMES_ENUM.RANGE_TOTAL,
            ...displayedBucketIdArray
        ];
    }
}

export {MetricAggregateViewMainTable};
export default withRouter(MetricAggregateViewMainTable);
